import { useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useStores } from "stores/setup/use-store";

const useForecastMapLayerData = () => {
  const {
    dataStores: { forecastMapStore },
  } = useStores();
  const { i18n, t } = useTranslation("translation", {
    keyPrefix: "layer",
  });
  const toast = useToast();
  const toastId = "toastInfoNoDataId";

  useEffect(() => {
    if (
      forecastMapStore.show &&
      forecastMapStore.selectedEnvironmentalVariable
    ) {
      forecastMapStore.fetchMapLayers().then((response) => {
        if (response && !response.success && !toast.isActive(toastId)) {
          toast({
            id: toastId,
            title: t("noLayerDataWasFound"),
            status: "error",
            position: "top",
            isClosable: true,
          });
        }
      });

      const interval = setInterval(() => {
        forecastMapStore.fetchMapLayers();
      }, 600000);

      return () => clearInterval(interval);
    } else {
      forecastMapStore.stop();
    }
  }, [
    forecastMapStore.isShowClicked,
    forecastMapStore.selectedEnvironmentalVariable,
    i18n.language,
  ]);

  return null;
};

export default useForecastMapLayerData;
